// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"bf6da6c6","420":"68bf26dd","539":"6a19752c","637":"087ea1c4","644":"e69cc658","775":"c42064dc","857":"3f1eba90","884":"76ebc28c","945":"adeb43ff"}[chunkId] + ".js";
};